/* eslint-disable no-console */

/**
 * PROP-086: PWA service worker СНЯТ.
 *
 * Прежний workbox-SW precache-кэшировал оболочку приложения (index.html + JS) и после деплоя
 * нового бандла продолжал отдавать СТАРЫЙ код из кэша. Старый код читал токен сессии из
 * localStorage (которого после PROP-086 там больше нет) и выбрасывал пользователя на /login.
 * Для бизнес-приложения, которым пользуются онлайн, офлайн-кэш оболочки пользы не давал, а
 * этот класс багов создавал.
 *
 * Поэтому: (1) новый бандл НЕ регистрирует никакого кэширующего SW; (2) активно снимает любую
 * оставшуюся регистрацию — БЕЗ перезагрузки, чтобы не зациклить; (3) на сервере по адресу
 * `service-worker.js` лежит kill-switch, который старые клиенты подхватят при штатной проверке
 * обновления своего SW и снимут его сами. Вместе это расклеивает уже застрявшие браузеры и не
 * даёт проблеме вернуться.
 */
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then(regs => regs.forEach(r => r.unregister()))
    .catch(() => {})
  // Чистим кэши workbox, если остались (без перезагрузки).
  if (typeof caches !== 'undefined') {
    caches.keys().then(keys => keys.forEach(k => caches.delete(k))).catch(() => {})
  }
}
